import { useState } from "react";
import "./ChangePasswordComponent.scss";
import "./ChangePasswordComponentMobile.scss";
import ItachiEyePassword from "../../../../../PageLogin/ItachiEyePassword/itachiEyePassword";
import PasswordStrength from "../../../../../PageSignup/PasswordInput/PasswordStrength";
import PasswordRequirements from "../../../../../PageSignup/PasswordInput/PasswordRequirements";
import SignupPasswordValidator from "../../../../../PageSignup/SignupPasswordValidator";
import { useAppContext } from "../../../../../Components/AppProvider";
import Modal from "./Modal/Modal";
import SendOTP2 from "./Modal/SendOTP2";

export default function ChangePasswordComponent() {
  const [isModalOpen, setModalOpen] = useState("");
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const { customerEmail } = useAppContext();

  const [currentPassword, currentNewPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordConfirm, setNewPasswordConfirm] = useState("");

  const validation = SignupPasswordValidator(newPassword);
  const allValid = Object.values(validation).every(Boolean);
  const passwordsMatch =
    newPassword && newPasswordConfirm && newPassword === newPasswordConfirm;
  const handleSharinganOldClick = () => {
    setShowOldPassword((prev) => !prev);
  };
  const handleSharinganClick = () => {
    setShowPassword((prev) => !prev);
  };
  const handleSharinganConfirmClick = () => {
    setShowConfirmPassword((prev) => !prev);
  };

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const handleChangePass = async () => {
    const email = customerEmail;
    if (!passwordsMatch) {
      alert("Passwords not matched.");
      return;
    }
    if (!email.trim()) {
      alert("Email is required.");
      return;
    } else if (!validateEmail(customerEmail)) {
      alert("Please enter a valid email address.");
      return;
    }
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/auth/change-password-otp`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ email, newPassword, currentPassword }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        alert(data.error || "Login failed. Please try again.");
      } else {
        setModalOpen("OTP"); // open modal
      }
    } catch (error) {
      console.error(error);
      alert("Network error. Please try again later.");
    }
  };
  return (
    <>
      <div className="change-pass-container">
        <div className="userChangePass-container">
          <div className="header">
            <div className="header-wrapper">CHANGE PASSWORD</div>
          </div>
          <div className="enter-password-wrapper">
            <span>Enter current password:</span>
            <div className="input-container">
              <div className="input-wrapper">
                <input
                  type={showOldPassword ? "text" : "password"}
                  value={currentPassword}
                  onChange={(e) => currentNewPassword(e.target.value)}
                />
                <ItachiEyePassword
                  className="sharingan"
                  onLoginClick={handleSharinganOldClick}
                />
              </div>
            </div>
          </div>
          <div className="enter-password-wrapper">
            <span>Enter new password:</span>
            <div className="input-container">
              <div className="input-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
                <ItachiEyePassword
                  className="sharingan"
                  onLoginClick={handleSharinganClick}
                />
              </div>

              <PasswordStrength allValid={allValid} />
            </div>
          </div>

          <PasswordRequirements validation={validation} />
          <div className="enter-password-wrapper">
            <span>Confirm new password:</span>
            <div className="input-container">
              <div className="input-wrapper">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  value={newPasswordConfirm}
                  onChange={(e) => setNewPasswordConfirm(e.target.value)}
                />

                <ItachiEyePassword
                  className="sharingan"
                  onLoginClick={handleSharinganConfirmClick}
                />
              </div>{" "}
              <div className="sp-form-password-strength">
                {newPasswordConfirm && (
                  <p className={passwordsMatch ? "valid" : "invalid"}>
                    {passwordsMatch ? "MATCHED" : "NOT MATCHED"}
                  </p>
                )}
              </div>
            </div>
          </div>

          <button className="otp-button" onClick={handleChangePass}>
            CHANGE PASSWORD
          </button>
        </div>
      </div>
      <Modal isModalOpen={isModalOpen} onClose={() => setModalOpen(false)}>
        {isModalOpen === "OTP" ? (
          <SendOTP2
            email={customerEmail}
            newPassword={newPassword}
            setModalOpen={setModalOpen}
            onClose={() => setModalOpen(false)}
            setNewPassword={setNewPassword}
            currentNewPassword={currentNewPassword}
            setNewPasswordConfirm={setNewPasswordConfirm}
          />
        ) : (
          ""
        )}
      </Modal>
    </>
  );
}
